import { ViewEmployee } from '@xeetr/types/models'

import ApiService from './common/API.service'

export class EmployeeService extends ApiService {
  getEmployees = async (): Promise<ViewEmployee[]> => {
    const { data } = await this.get<ViewEmployee[]>(this.buildTenantUrl('employees'))
    return data
  }

  patchEmployee = async (id: string, employee: Partial<ViewEmployee>): Promise<ViewEmployee> => {
    const { data } = await this.patch<unknown, ViewEmployee>(
      this.buildTenantUrl(`employees/${id}`),
      employee
    )
    return data
  }

  createEmployee = async (employee: ViewEmployee): Promise<ViewEmployee> => {
    const { data } = await this.post<ViewEmployee, ViewEmployee>(
      this.buildTenantUrl('employees'),
      employee
    )
    return data
  }

  deleteEmployee = async (id: string): Promise<void> => {
    await this.delete(this.buildTenantUrl(`employees/${id}`))
  }
}
